// export async function initVueComponent
export function formatNumber(number: number | string, decimals: number, dec_point: string, thousands_sep: string) {
	let sign = number < 0 ? '-' : '';

	let s_number: string = Math.abs(parseInt((number = (+number || 0).toFixed(decimals)))) + '';
	let len = s_number.length;
	let tchunk = len > 3 ? len % 3 : 0;

	let ch_first = tchunk ? s_number.substr(0, tchunk) + thousands_sep : '';
	let ch_rest = s_number.substr(tchunk).replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
	let ch_last = decimals
		? dec_point + (Math.abs(parseFloat(number)) - parseFloat(s_number)).toFixed(decimals).slice(2)
		: '';

	return sign + ch_first + ch_rest + ch_last;
}

export function easeInOutQuad(t: number, b: number, c: number, d: number) {
	t /= d / 2;
	if (t < 1) return (c / 2) * t * t + b;
	t--;
	return (-c / 2) * (t * (t - 2) - 1) + b;
}

export function decOfNum(number: number, titles: string[]) {
	let decCache: number[] = [],
		decCases = [2, 0, 1, 1, 1, 2];
	if (!decCache[number])
		decCache[number] = number % 100 > 4 && number % 100 < 20 ? 2 : decCases[Math.min(number % 10, 5)];
	return titles[decCache[number]];
}

export function randomInteger(min: number, max: number) {
	let rand = min - 0.5 + Math.random() * (max - min + 1);
	rand = Math.round(rand);
	return rand;
}

export async function importTinySlider() {
	const { tns } = await import(/* webpackChunkName: "tiny" */ 'tiny-slider/src/tiny-slider');
	return tns;
}
